enum ActionStyle {
  BUTTON = 'button',
  ICON = 'icon',
  TEXT = 'text',
}

export default ActionStyle;
